import type { Area } from "@/areas/types";
import { areaHousesGateway } from "@/gateways/areaHousesGateway";
import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref } from "vue";

export function useGetAreaHouses(area: Ref<Area | undefined>) {
  const query = useQuery({
    queryKey: computed(() => ["areaHouses", area.value?.id]),
    queryFn: () =>
      area.value === undefined
        ? Promise.resolve([])
        : areaHousesGateway.getAreaHouses(area.value.id),
    initialData: [],
  });

  return {
    ...query,
    getAreaHousesStatus: query.status,
    houses: query.data,
  };
}
